@for (topic of topics(); track topic.name) {
	<button class="topic" (click)="openTopicNotes(topic)" (mouseenter)="showTopicNotes(topic)" (focus)="showTopicNotes(topic)" mat-stroked-button>{{topic.name}}</button>
}
<app-horizontal-scroll-buttons no-opacity />



<ng-template #topicNotesSheet>
	<h3>{{selectedTopic()?.name}}</h3>
	<p [innerHTML]="selectedTopic()?.notes | newlinesToBr"></p>
	<button (click)="closeTopicNotes()" class="close-topic" aria-label="Close topic" matTooltip="Close topic" mat-icon-button>
		<mat-icon>close</mat-icon>
	</button>
</ng-template>

<ng-template #topicNotesDialog>
	<h2 mat-dialog-title>Topic: {{selectedTopic()?.name}}</h2>
	<mat-dialog-content>
		<p [innerHTML]="selectedTopic()?.notes | newlinesToBr"></p>
	</mat-dialog-content>
	<mat-dialog-actions>
		<button mat-button [mat-dialog-close]="false">Okay</button>
	</mat-dialog-actions>
</ng-template>
